import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { CAUSES, DEFAULT_IMAGE_URLS } from '../Constants';

export const IMAGE_PROPS = {
    trackImageCloudinary: {
        dimension: { h: 230, w: 480 },
        cloudinaryCrop: 'fill'
    },
    learningAssetImageCloudinary: {
        dimension: { h: 250, w: 250 },
        cloudinaryCrop: 'fill'
    },
    badgeImageCloudinary: {
        dimension: { h: 80, w: 80 },
        cloudinaryCrop: 'fill'
    },
    collectionImageCloudinary: {
        dimension: { h: 250, w: 250 },
        cloudinaryCrop: 'fill'
    },
    collectionHeadingImageCloudinary: {
        dimension: { h: 200, w: 200 },
        cloudinaryCrop: 'fill'
    },
    pathwayHeadingImageCloudinary: {
        dimension: { h: 300, w: 442 },
        cloudinaryCrop: 'fill'
    },
    pathwayBadgeImageCloudinary: {
        dimension: { h: 110, w: 110 },
        cloudinaryCrop: 'fill'
    },
    collectionBadgeImageCloudinary: {
        dimension: { h: 250, w: 250 },
        cloudinaryCrop: 'fit'
    },
    pathwayAssetInterstitialImageCloudinary: {
        dimension: { h: 78, w: 100 },
        cloudinaryCrop: 'fill'
    }
};

export const overlayImageIds = {
    checkmark: 'icon_check',
    collection: 'icon_collection',
    locked: 'lock_overlay',
    lockedGrey: 'overlay_locked_gray',
    complete: 'overlay_complete',
    inProgress: 'overlay_in-progress'
};

export const imagesForCauses = {
    black: {
        education: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/Education_wgwscv.png',
        environment: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/Environment_di0mfv.png',
        health: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/HealthandWellness_nccn94.png',
        poverty: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/PovertyAlleviation_nusdnj.png',
        food: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/FoodandNutrition_yl4qoj.png',
        equality: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/GenderEquality_g3zbde.png',
        humanRights: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/HumanRights_uqdoju.png',
        animalWelfare: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/AnimalWelfare_nxtp1y.png',
        civicEngagement: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/CivicEngagement_j5pqcu.png',
        artsAndCulture: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/ArtsandCulture_k1unhn.png',
        futurism: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/Futurism_wkb4kp.png',
        other: ''
    },
    pink: {
        education: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/Education_Pink_kpkvth.png',
        environment: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/Environment_Pink_i42tf2.png',
        health: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/HealthandWellness_Pink_ty5sm2.png',
        poverty: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/PovertyAlleviation_Pink_fgv0lb.png',
        food: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/FoodandNutrition_Pink_rqgcdy.png',
        equality: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/GenderEquality_Pink_gbcisr.png',
        humanRights: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/HumanRights_Pink_ursm5s.png',
        animalWelfare: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/AnimalWelfare_Pink_cdoq8q.png',
        civicEngagement: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/CivicEngagement_Pink_a99pfi.png',
        artsAndCulture: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037859/ArtsandCulture_Pink_dcndqs.png',
        futurism: 'http://res.cloudinary.com/verb-prod/image/upload/v1495037860/Futurism_Pink_y7mqil.png',
        other: ''
    }
};

export const imagesForCausesV2 = {
    inactive: {
        education: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430161/Icon_Cause_Education_sv2y2v.svg',
        environment: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430159/Icon_Cause_Environment_vaaajo.svg',
        health: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430159/Icon_Cause_Health_znfzlm.svg',
        poverty: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430164/Icon_Cause_Poverty_dio90e.svg',
        food: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430159/Icon_Cause_Food_ygqbbv.svg',
        equality: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430162/Icon_Cause_Gender_nfq7ko.svg',
        humanRights:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503526195/Constants/Causes/Icon_Cause_Human.svg',
        animalWelfare:
            'https://res.cloudinary.com/verb-prod/image/upload/v1503504815/Constants/Causes/Icon_Cause_Animal.svg',
        civicEngagement: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430162/Icon_Cause_Civic_qt2qk6.svg',
        artsAndCulture: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430165/Icon_Cause_Arts_cpfwxw.svg',
        futurism: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430164/Icon_Cause_Futurism_rli7o2.svg',
        other: 'http://res.cloudinary.com/verb-prod/image/upload/v1503526530/Constants/Causes/Icon_Cause_Other.svg'
    },
    active: {
        education:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503430155/Icon_Cause_Education_Active_kiyqse.svg',
        environment:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503430157/Icon_Cause_Environment_Active_klpb51.svg',
        health: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430155/Icon_Cause_Health_Active_n2vnse.svg',
        poverty: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430155/Icon_Cause_Poverty_Active_czf6md.svg',
        food: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430152/Icon_Cause_Food_Active_tksdus.svg',
        equality: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430152/Icon_Cause_Gender_Active_y0kfdc.svg',
        humanRights:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503526195/Constants/Causes/Icon_Cause_Human_active.svg',
        animalWelfare:
            'https://res.cloudinary.com/verb-prod/image/upload/v1503504815/Constants/Causes/Icon_Cause_Animal_Active.svg',
        civicEngagement:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503430152/Icon_Cause_Civic_Active_hptvu9.svg',
        artsAndCulture:
            'http://res.cloudinary.com/verb-prod/image/upload/v1503430152/Icon_Cause_Arts_Active_dbrsg1.svg',
        futurism: 'http://res.cloudinary.com/verb-prod/image/upload/v1503430152/Icon_Cause_Futurism_Active_gwezgp.svg',
        other: 'http://res.cloudinary.com/verb-prod/image/upload/v1503526440/Constants/Causes/Icon_Cause_Other_Active.svg'
    }
};

/**
 * Returns true if the hostname belongs to cloudinary
 * @param {string} hostname
 * @return {boolean}
 */
export const isCloudinaryHostedImage = (hostname) =>
    (hostname || '').toLocaleUpperCase() === 'res.cloudinary.com'.toLocaleUpperCase();

const _createLText = (textOptions) => {
    const lTextString = [];
    const textBackground = [];
    if (textOptions) {
        if (textOptions.l_text) {
            lTextString.push(`l_text:${textOptions.l_text}`);
        }
        if (textOptions.textAlignment) {
            lTextString.push(`alignmentvalue_${textOptions.textAlignment}`);
        }
        if (textOptions.textY) {
            textBackground.push(`y_${textOptions.textY}`);
        }
        if (textOptions.textX) {
            textBackground.push(`x_${textOptions.textX}`);
        }
        if (textOptions.gravity) {
            textBackground.push(`g_${textOptions.gravity}`);
        }
        if (textOptions.textColor) {
            textBackground.push(`co_rgb:${textOptions.textColor}`);
        }
        if (textOptions.backgroundWidth) {
            textBackground.push(`c_fit,w_${textOptions.backgroundWidth}`);
        }
        if (textOptions.backgroundHeight) {
            textBackground.push(`h_${textOptions.backgroundHeight}`);
        }

        return `${lTextString.join('_')}:${textOptions.textMessage.split(' ').join('%20')}${
            textBackground.length ? `,${textBackground.join(',')}` : ''
        }`;
    }
    return '';
};

/**
 *
 * @param {string} imageSrc
 * @param {Object} options
 * @param {number} [options.w] Expected width of the image
 * @param {number} [options.h] Expected height of the image
 * @param {string} [options.crop]
 * @return {string}
 */
export const attachCloudinaryOptionsToImageSource = (imageSrc, options = {}) => {
    // replaces all http with https images
    let optimizedSource = imageSrc.replace('http:', 'https:');

    const replacementString = [];
    const overlayString = [];

    if (get(options, 'w', '')) {
        replacementString.push(`w_${options.w}`);
    }
    if (get(options, 'h', '')) {
        replacementString.push(`h_${options.h}`);
    }
    if (get(options, 'crop', '')) {
        replacementString.push(`c_${options.crop}`);
    }

    if (get(options, 'radius', '')) {
        replacementString.push(`r_${options.radius}`);
    }
    if (get(options, 'effect', '')) {
        replacementString.push(`e_${options.effect}`);
    }

    if (get(options, 'q', '')) {
        replacementString.push(`q_${options.q}`);
    } else {
        replacementString.push('q_auto');
    }
    if (options.ext) {
        replacementString.push(`f_${options.ext}`);
    } else {
        replacementString.push('f_auto');
    }

    if (get(options, 'color', '')) {
        if (get(options, 'colorize', '')) {
            replacementString.push(`e_colorize:${options.colorize},co_rgb:${options.color}`);
        } else {
            replacementString.push(`e_colorize:66,co_rgb:${options.color}`);
        }
    }

    if (get(options, 'overlay', '')) {
        if (get(options, 'overlayDimensions.w', '')) {
            overlayString.push(`w_${options.overlayDimensions.w}`);
        }
        if (get(options, 'overlayDimensions.h', '')) {
            overlayString.push(`h_${options.overlayDimensions.h}`);
        }
        if (options.overlayGravity) {
            overlayString.push(`g_${options.overlayGravity}`);
        }
        if (options.overlayOpacity) {
            overlayString.push(`o_${options.overlayOpacity}`);
        }
        overlayString.push(`l_${options.overlay}`);

        if (replacementString.length > 0) {
            replacementString[replacementString.length - 1] = `${
                replacementString[replacementString.length - 1]
            }/${overlayString.join(',')}`;
        }
    }

    if (options.text) {
        let textString;
        if (!Array.isArray(options.text)) {
            textString = _createLText(options.text);
        } else {
            const multiText = options.text.map(_createLText);
            textString = multiText.join('/');
        }

        if (replacementString.length > 0) {
            replacementString[replacementString.length - 1] = `${
                replacementString[replacementString.length - 1]
            }/${textString}`;
        }
    }

    if (replacementString.length > 0) {
        if (get(options, 'firstOverlay', '')) {
            replacementString[replacementString.length - 1] = `${replacementString[replacementString.length - 1]}/${
                options.firstOverlay
            }`;
        }

        if (get(options, 'secondOverlay', '')) {
            replacementString[replacementString.length - 1] = `${replacementString[replacementString.length - 1]}/${
                options.secondOverlay
            }`;
        }
        optimizedSource = optimizedSource.replace(/\/v\d+\//i, `/${replacementString.join(',')}/`);
    }
    return optimizedSource;
};

const removeSpecialChar = (string) => {
    let newString;
    newString = string.replace(',', '%252C');
    newString = newString.replace('?', '%3F');
    return newString;
};

export const createUserCertificate = (userName, collectionName, date, type = 'PATHWAY') => {
    let linkURL = DEFAULT_IMAGE_URLS.CERTIFICATE_BLANK_PATHWAY;
    if (type === 'COLLECTION') {
        linkURL = DEFAULT_IMAGE_URLS.CERTIFICATE_BLANK;
    }
    return attachCloudinaryOptionsToImageSource(linkURL, {
        ext: 'pdf',
        text: [
            {
                l_text: 'Montserrat-Bold.ttf_250',
                textAlignment: 'center',
                textMessage: userName,
                gravity: 'north',
                textColor: 'CD2D72',
                textY: 790
            },
            {
                l_text: 'Montserrat-Medium.ttf_115',
                textAlignment: 'center',
                textMessage: removeSpecialChar(collectionName),
                gravity: 'north',
                textColor: '000000',
                textY: 1280
            },
            {
                l_text: 'Parisienne-regular.ttf_100',
                textAlignment: 'center',
                textMessage: moment(date).format('MMMM D[%252C] YYYY').toString(),
                gravity: 'north',
                textColor: '000000',
                textY: 1850,
                textX: 820
            }
        ]
    });
};

/**
 *
 * @param {string} imageSrc
 * @param {Object} options
 * @param {number} options.w Expected width of the image
 * @param {number} options.h Expected height of the image
 * @param {string} [options.repeatOption='no-repeat']
 * @param {string} [options.sizeOption='cover']
 * @param {string} [options.positionOption='']
 * @return {{backgroundImage: string}}
 */
export const buildBackgroundImageStyleObject = (imageSrc, options = {}) => {
    const parser = document.createElement('a');
    parser.href = imageSrc;

    let optimizedSource = imageSrc;
    if (isCloudinaryHostedImage(parser.hostname)) {
        // replaces all http with https images
        optimizedSource = attachCloudinaryOptionsToImageSource(optimizedSource, options);
    }

    const repeatOption = get(options, 'repeatOption', 'no-repeat');
    const sizeOption = get(options, 'sizeOption', 'cover');
    const positionOption = get(options, 'positionOption', '');

    /**
   * -webkit-background-size: cover;
   -moz-background-size: cover;
   -o-background-size: cover;
   */
    if (!optimizedSource) {
        return null;
    }

    const result = {
        backgroundImage: `url(${optimizedSource})`,
        backgroundRepeat: repeatOption,
        backgroundSize: sizeOption
    };

    if (!isEmpty(positionOption)) {
        result.backgroundPosition = positionOption;
    }

    return result;
};

/**
 *
 * @param {Array} causes
 * @param color
 * @return {Array}
 */
export const getImagesForCauses = (causes, color = 'black') => {
    if (!causes) {
        return [];
    }

    let causeCounter = 0;
    const userCausesObject = causes.reduce((acc, cause) => {
        causeCounter += 1;
        acc[cause] = imagesForCauses[color][cause];
        return acc;
    }, {});
    const causeArray = [];
    for (let i = 0; i < CAUSES().length; i += 1) {
        const causeObject = {};
        if (userCausesObject[CAUSES()[i].value]) {
            causeCounter -= 1;
            causeObject.icon = userCausesObject[CAUSES()[i].value];
            causeObject.value = CAUSES()[i].value;
            causeObject.label = CAUSES()[i].label;
            causeArray.push(causeObject);
        }
        if (!causeCounter) {
            return causeArray;
        }
    }
    return causeArray;
};
